var Backbone = require('backbone');
var _ = require('underscore/underscore');
var Utils = require('front/utils/Utils');
require('jquery.dotdotdot');
var FontFaceObserver = require('fontfaceobserver');

require('front/components/Category/Category');
require('front/components/CommentCount/CommentCount');
require('./ArticleItem.less');
require('front/components/ViewCount/ViewCount');

module.exports = Backbone.View.extend({
    events: {
        'mouseenter .ArticleItem-title': 'hoverOn',
        'mouseleave .ArticleItem-title': 'hoverOff'
    },

    initialize: function () {
        this.state = {};
        this.state.commentShown = false;

        // this.checkVisibility = _.throttle(this._checkVisibility.bind(this), 75);

        // this.$comment = this.$('.ArticleItem-comment');
        // if (this.$comment.length) {
        //     app.els.$window.on('scroll resize', this.checkVisibility);
        // }

        this.$title = this.$('.ArticleItem-title');
        this.$lead = this.$('.ArticleItem-lead');

        this.checkTitles();
    },

    // _checkVisibility: function () {
    //     if (!this.state.commentShown && Utils.isElementInViewport(this.$el, 130, 50)) {
    //         this.showComment();
    //     }
    // },
    //
    // showComment: function () {
    //     app.els.$window.off('scroll resize', this.checkVisibility);
    //
    //     $.Velocity(this.$comment[0], {opacity: 1}, {display: 'flex', delay: 500, duration: 250})
    //         .then(function () {
    //             return $.Velocity(this.$comment[0], {opacity: 0}, {display: 'none', delay: 5000, duration: 250});
    //         }.bind(this));
    // },

    checkTitles: function () {
        var fontRaleway = new FontFaceObserver('Raleway', {
            weight: 800
        });

        var fontOpenSans = new FontFaceObserver('Open Sans', {
            weight: 400
        });

        Promise.all([fontRaleway.load(), fontOpenSans.load()]).then(function () {
            this.$title.dotdotdot();
            this.$lead.dotdotdot();
        }.bind(this));
    },

    hoverOn: function () {
        this.$el.addClass('ArticleItem--hover');
    },

    hoverOff: function () {
        this.$el.removeClass('ArticleItem--hover');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ArticleItem/ArticleItem.js
// module id = 165
// module chunks = 0